export default "/images/share-2.svg?709c4a04c43066332bd70478c6a18f38";